<template>
    <div>
        <law-event-form :getLawEventList="getLawEventList" 
        ref="lawEventFormModal" :matterTypeHistoryId = matterTypeHistoryId>
        </law-event-form>
        <b-row>
            <b-col class="col-12">
                <div style="float:left;" class="custom-search d-flex justify-content-end">
                    <b-form-group>
                        <div class="d-flex align-items-center">
                            <b-form-input size="sm" v-model="searchTerm" :placeholder="$t('others.search')" type="text" class="d-inline-block" />
                        </div>
                    </b-form-group>
                </div>
                <div style="float:right;" class="custom-search d-flex justify-content-end">
                    <b-form-group>
                        <div class="d-flex align-items-center">
                            <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="getInfo(0)">{{ $t('lawEvent.add') }}</b-button>
                        </div>
                    </b-form-group>
                </div>
            </b-col>
        </b-row>
        <vue-good-table 
      id="lawEventTable"
      ref="lawEventTable" 
      :columns="columns" 
      :rows="rows" 
      styleClass="vgt-table condensed tableSize" 
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }" 
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, 
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, 
        selectAllByGroup: true,
      }" 
      :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" theme="my-theme">
        <div slot="emptystate">
          {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.field === 'date'" class="text-nowrap">
            {{ $t('lawEvent.date') }}
          </span>
           <span v-if="props.column.field === 'lawEventTypeName'" class="text-nowrap">
            {{ $t('lawEvent.law_event_type_name') }}
          </span>
           <span v-if="props.column.field === 'location'" class="text-nowrap">
            {{ $t('lawEvent.location') }}
          </span>
           <span v-if="props.column.field === 'note'" class="text-nowrap">
            {{ $t('lawEvent.note') }}
          </span>
          <span v-else-if="props.column.field === 'process'" class="text-nowrap">
          </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
          <!-- Column: Process -->
            <span v-if="props.column.field === 'note'">
                <div v-b-tooltip.hover="{ title: props.row.note, customClass: 'wh-tooltip' }" class="wh-clamp-2">{{ props.row.note }}</div>
            </span>
            <span v-else-if="props.column.field === 'process'">
                <list-actions-dropdown :actions="[
                    { icon: 'EditIcon', label: $t('others.edit'), handler: () => getInfo(props.row.id) },
                    { icon: 'XIcon', label: $t('others.delete'), color: '#DC2626', handler: () => deleted(props.row) }
                ]" />
            </span>
        </template>
  
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
              </span>
              <b-form-select v-model="pageLength" :options="['10', '25', '50', '100']" class="mx-1"
                @input="(value) => props.perPageChanged({ currentPerPage: value })" />
              <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
            </div>
            <div>
              <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number
                align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </div>
</template>

<script>

 
 export default {
    props: {
        matterTypeHistoryId: {type: Number}
    },
    data() {
      return {
        pageLength: 50,
        dir: false,
        columns: [
          {
            label: this.$t('lawEvent.date'),
            field: `date`,
            formatFn: this.$formatFn
          },
          {
            label: this.$t('lawEvent.law_event_type_name'),
            field: `lawEventTypeName`,
           
          },
          {
            label: this.$t('lawEvent.location'),
            field: `location`,
           
          },
          {
            label: this.$t('lawEvent.note'),
            field: `note`,
          },
          {
            label: '',
            field: 'process',
            width: '10em',
            sortable: false
          },
        ],
        rows: [],
        searchTerm: '',
      }
    },
    mounted() {
      this.getLawEventList()
    },
    methods: {
        async getInfo(id) {
        this.$refs.lawEventFormModal.showInfo(id)
        },
        async getLawEventList(){
            this.rows = []
            const data = { id: this.matterTypeHistoryId }
            const controller = {
                name: 'LawEvent',
                actionName: 'GetLawEventListByMatterTypeHistoryId'
            }
            const payload = { controller: controller,  data: data}
            const response = await  this.$store.dispatch('moduleAuth/customService', payload)
                if (response.data.resultStatus) {
                    response.data.lawEventList.forEach(element => {
                        this.rows.push(element)
                    })
                    this.emitLastMeetingDate(this.rows)

                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }     
        },
        emitLastMeetingDate(rows){
            if(rows && rows.length > 0 ){
                const maxDateObject = rows.reduce((latest, current) => {
                const latestDate = new Date(latest.date);
                const currentDate = new Date(current.date);
                return currentDate > latestDate ? current : latest;
                });
                this.$emit('parentEvent', maxDateObject.date);
            }else{
                 this.$emit('parentEvent', null);
            }
        },
        async deleted(data) {
        data = { id: data.id }
        const controller = { name: 'LawEvent' }
        const payload = { data: data, controller: controller }
        this.$DeleteConfirm().then(result => {
          if (result.value) {
            this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
              if (response.data.resultStatus == true) {
                this.$DeleteAlert()
                this.getLawEventList()
              } else {
                this.$WarningAlert(response.data.resultMessage)
                this.getLawEventList()
              }
            })
          }
        })
      },
    }
 }
</script>